//import Vue from 'vue';

export const CLEAR_CHILD = 'clearChild';
export const SET_CHILD = 'setChild';

export const CLEAR_CHILDREN = 'clearChildren';
export const SET_CHILDREN = 'getChildren';

export const CLEAR_PROFILE = 'clearProfile';
export const SET_PROFILE = 'setProfile';
export const SET_NUBE = 'setNube';
export const SET_AFTER_REGISTER = 'setAfterRegister';
export const SET_LOADING = 'setLoading';
export const PROFILE_LOADED = 'profileLoaded';

export const MUTATIONS = {
  CLEAR_CHILDREN,
  SET_CHILDREN,

  CLEAR_CHILD,
  SET_CHILD,

  CLEAR_PROFILE,
  SET_PROFILE,
  SET_NUBE,
  SET_LOADING,
  PROFILE_LOADED,
};

const mutations = {
  [CLEAR_CHILD]: (state, id) => {
    const index = state.children ? state.children.findIndex(child => id === child.id) : -1;
    if (index === -1) {
      return false;
    }
    state.children.splice(index, 1);
    return true;
  },

  [SET_CHILD]: (state, payload) => {
    if (!Array.isArray(state.children)) {
      state.children = [];
    }
    const index = state.children.findIndex(({ id }) => id === payload.id);
    if (index !== -1) {
      state.children[index] = payload;
    } else {
      state.children.push(payload);
    }
  },

  [CLEAR_PROFILE]: state => {
    state.profile = null;
  },

  [SET_PROFILE]: (state, payload) => {
    state.profile = {
      ...(state.profile || {}),
      ...payload,
    };
  },

  [SET_NUBE]: (state, payload = false) => {
    state.nube = !!payload;
  },

  [SET_AFTER_REGISTER]: (state, payload = false) => {
    state.after_register = !!payload;
  },

  [CLEAR_CHILDREN]: state => {
    state.children = null;
  },

  [SET_CHILDREN]: (state, children) => {
    state.children = [...children];
  },

  [SET_LOADING]: (state, payload) => {
    state.loading = payload;
  },
  [PROFILE_LOADED]: (state, payload) => {
    state.profileLoaded = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/user/mutations.js